// extracted by mini-css-extract-plugin
module.exports = {"grid":"FilterExplanationEdit_grid__19w5L","subHeader":"FilterExplanationEdit_subHeader__11ki5","left":"FilterExplanationEdit_left__lFW8-"};